import { getCorporationRefundData, setCorporationRefundData } from '@/components/tax-refund/common/data/corporation-refund-data';
import { getIndisSearchRefundData, setIndisSearchRefundData } from '@/components/tax-refund/common/data/indis-search-refund-data';

interface CorpSessionStorageDataType {
  authType?: 'hometax' | 'joint-certificate';
  serviceAgreementFlow: boolean;
  marketingAgree?: boolean;
  thirdAgree?: boolean;
  refundToken?: string;
  refundId?: string;
  refundAmount?: string;
  refundStatus?: string;
  bizName?: string;
  tin?: string;
  regNo?: never;
  // 계좌입력 정보
  bank?: string;
  accountNo?: string;
  accountOwner?: string;
  // 제휴사 할인 정보
  partnerName?: string;
  feeRate?: string;
  defaultFeeRate?: string;
  // 홈택스 아이디 입력 화면 자동 채우기를 위한 필드
  hometaxId?: string;
  tritxRefundInfo?: never;
}

interface IndisSessionStorageDataType {
  bizName: string;
  refundAmount: string;
  refundId: string;
  bank?: string;
  accountNo?: string;
  accountOwner?: string;
  tin?: string;
  refundStatus: string;
  tritxRefundInfo?: {
    bizName: string;
    refundAmount: string;
    refundId: string;
    refundStatus: string;
    businessInfo: {
      taxpayerName: string;
    };
  };
}

type GetRefundDataForWebStorageReturnType = {
  indis: IndisSessionStorageDataType;
  corps: CorpSessionStorageDataType;
};
export const getRefundDataForWebStorage = (type: 'indis' | 'corps'): GetRefundDataForWebStorageReturnType => {
  const data = { indis: {} as IndisSessionStorageDataType, corps: {} as CorpSessionStorageDataType };
  if (type === 'corps') {
    const corpData = getCorporationRefundData();
    data.corps = { ...corpData, serviceAgreementFlow: !!corpData?.serviceAgreementFlow };
  } else {
    const indisData = getIndisSearchRefundData();
    data.indis = {
      ...indisData,
      bizName: indisData?.bizName || '',
      refundAmount: indisData?.refundAmount || '',
      refundId: indisData?.refundId || '',
      refundStatus: indisData?.refundStatus || '',
      tritxRefundInfo: indisData?.tritxRefundInfo || undefined
    };
  }

  return data;
};

type IndisRefundData = {
  type: 'indis';
  data: IndisSessionStorageDataType;
};
type CorpsRefundData = {
  type: 'corps';
  data: CorpSessionStorageDataType;
};
export type SetRefundDataForWebStorageParams = IndisRefundData | CorpsRefundData;
export const setRefundDataForWebStorage = (params: SetRefundDataForWebStorageParams) => {
  if (params.type === 'corps') {
    setCorporationRefundData(params.data);
  } else {
    setIndisSearchRefundData(params.data);
  }
};
